export default [
    {
        path: 'relatorio-medicamento-nao-atendido',
        component: () => import(/* webpackChunkName: 'farmacia-relatorio-dispensacao-remedio-casa' */ '@/views/farmacia/relatorio-medicamento-nao-atendido/Index'),
        redirect: 'relatorio-medicamento-nao-atendido/index',
        children: [
            {
                name: 'relatorio-medicamento-nao-atendido-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'farmacia-relatorio-dispensacao-remedio-casa' */ '@/views/farmacia/relatorio-medicamento-nao-atendido/List'),
            },
        ],
    },
]